module.exports = __webpack_public_path__ + "media/bootstrap-icons/palette-4e948031.svg";